import { MERCHANT_ADMIN_MEMBER_DETAILS } from "constants/action-types";
import { IFetchParams, progressEpic } from "./base-epic";
import { IMember } from "constants/merchants";
import { format } from "lib/globalize-util";
import { pickGrpcError } from "helpers/epics";
import { snackbarAdd } from "actions/snackbars";
import { DATATEST } from "constants/integration";

export const fetchMemberEpic = progressEpic<IFetchParams, IMember>(
    MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER.FETCH,
    ({ payload }) => ({
        method: payload.method,
        url: payload.url,
    })
);

export const fetchMemberAttributesEpic = progressEpic<IFetchParams, IMember>(
    MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER_BASIC_PROFILE.FETCH,
    ({ payload }) => ({
        method: payload.method,
        url: payload.url,
    })
);

export const muateMemberAttributes = progressEpic<IFetchParams, never>(
    MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER_BASIC_PROFILE.MUTATE,
    ({ payload }) => ({
        method: payload.method,
        url: payload.url,
        body: payload.body,
    }),
    {
        finishActions: () => [
            snackbarAdd({
                message: format("Member attributes updated"),
                testId: DATATEST.MERCHANT_ADMIN_MEMBER_DETAILS.ACTION_SUCCESS_MESSAGE,
            }),
        ],
        errorActions: (error) => [
            snackbarAdd({
                message: format("Error while trying to update member profile: |errorMessage|", {
                    errorMessage: pickGrpcError(error) || format("Unknown"),
                }),
                testId: DATATEST.MERCHANT_ADMIN_MEMBER_DETAILS.ACTION_ERROR_MESSAGE,
            }),
        ],
    }
);

export const deactivateMemberEpic = progressEpic<IFetchParams, never>(
    MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER.DEACTIVATE,
    ({ payload }) => ({
        method: payload.method,
        url: payload.url,
    }),
    {
        errorActions: (error) => [
            snackbarAdd({
                message: pickGrpcError(error),
                testId: DATATEST.MERCHANT_ADMIN_MEMBER_DETAILS.ACTION_ERROR_MESSAGE,
            }),
        ],
    }
);

export const activateMemberEpic = progressEpic<IFetchParams, never>(
    MERCHANT_ADMIN_MEMBER_DETAILS.MEMBER.ACTIVATE,
    ({ payload }) => ({
        method: payload.method,
        url: payload.url,
    }),
    {
        errorActions: (error) => [
            snackbarAdd({
                message: pickGrpcError(error),
                testId: DATATEST.MERCHANT_ADMIN_MEMBER_DETAILS.ACTION_ERROR_MESSAGE,
            }),
        ],
    }
);
